export const ParcoursTypeEnum = {
    ASSIGNED: 'ASSIGNED',
    CREATED: 'CREATED',
    SHARED: 'SHARED',
    INITIAL: 'INITIAL'
};
